export default __webpack_public_path__ + "7c5c4ff958a3431608770c2fec6392a9.svg";